


























































































import { Vue, photosUrlEnum } from "../../constants/constants";
import { getRemoteConfigAsBoolean } from "../../firebase";
import { staticContent } from "../../localisation/detect-lang";
import { BasketLoadersEnum } from "../../models/basket.model";

export default Vue.component("people-view", {
  data() {
    return {
      staticContent,
      photosUrlEnum,
      basketLoader: BasketLoadersEnum,
    };
  },
  props: {
    componentname: null,
    users: null,
    adminuuid: null,
  },
  computed: {
    profile() {
      return this.$store.getters.getProfileData;
    },
    groupBasket() {
      return this.$store.state.groupBasket;
    },
    isGroupAdmin() {
      return (this.profile && this.profile.uuid) == this.adminuuid;
    },
    currentUser() {
     if (this.profile && this.users) {
        let arr = [...this.users]; 
        let indexOfCurrentUser = arr.findIndex(
          (item) => item.userUUID == this.profile.uuid
        );
        return arr[indexOfCurrentUser];
      } else return null;
    },
    filterBasketUsers() {
      let arr = [...this.users];
      if (this.profile) {
        let indexOfCurrentUser = arr.findIndex(
          (item) => item.userUUID == this.profile.uuid
        );
        arr.splice(0, 0, arr.splice(indexOfCurrentUser, 1)[0]);
        return arr;
      } else return arr;
    },
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    view1() {
      return getRemoteConfigAsBoolean("Split_Wallet_View1_Web");
    },
    view2() {
      return getRemoteConfigAsBoolean("Split_Wallet_View2_Web");
    },
    view3() {
      return getRemoteConfigAsBoolean("Split_Wallet_View3_Web");
    },
  },

  methods: {
    collapseHandler(target) {
      this.$root.collapseHandler(target);
    },
    getUserItemsCount(user) {
      let itemscount = 0;
      user.categories.forEach(function (catItem) {
        itemscount += catItem.items.reduce(
          (count, current) => count + current.quantity,
          0
        );
      });

      return itemscount;
    },
    isUserItemsWithError(user) {
      return user.categories.some((catItem) =>
        catItem.items.some((item) => item.error != null)
      );
    },
    toFixedPrice(price) {
      return this.$root.toFixedPrice(price);
    },
  },
});
